<!--suppress AngularNgOptimizedImage-->
<div class="ion-page">
  <ion-content [fullscreen]="true">
    <div class="background">
      <header class="header">
        <app-responsive-container>
          <div class="header-button">
            <app-animated-container [animationTrigger]="backButtonTextAnimationTrigger">
              @if (backButtonText || allowCleanup) {
                <div class="header-button-left">
                  @if (backButtonText) {
                    <ion-button (click)="this.brandingLayoutService.backButton()" fill="clear">
                      <ion-icon slot="start" name="chevron-back"></ion-icon>
                      {{ 'Back' | translate }}
                    </ion-button>
                  }
                </div>
              }
            </app-animated-container>
          </div>

          <div class="header-button">
            <app-animated-container [animationTrigger]="languageButtonTextAnimationTrigger">
              @if (languageButtonText) {
                <div style="position: relative; width: 100%; display: flex; justify-content: flex-end;">
                  <ion-button (click)="changeLanguage()" fill="clear">
                    <ion-icon slot="start" name="language"></ion-icon>
                    {{ languageButtonText }}
                  </ion-button>
                  <ion-button (click)="openSupportUrl()" fill="clear">
                    <ion-icon slot="start" name="help-circle-outline"></ion-icon>
                  </ion-button>
                </div>
              }
            </app-animated-container>
          </div>
        </app-responsive-container>

        <div class="header-padding-top"></div>

        <app-responsive-container>
          <div class="ion-padding">
            <app-animated-logo></app-animated-logo>

            <app-animated-container [animationTrigger]="headerTextAnimationTrigger">
              @if (headerText) {
                <ion-row class="ion-justify-content-center">
                  <ion-col size="auto" class="ion-no-padding ion-margin-top">
                    <ion-text class="header-text ion-text-center" color="light">
                      <h5 class="ion-no-margin"><strong>{{ headerText | translate }}</strong></h5>
                    </ion-text>
                  </ion-col>
                </ion-row>
              }
            </app-animated-container>

            <app-animated-container [animationTrigger]="headerButtonTextAnimationTrigger">
              @if (headerButtonText) {
                <ion-row class="ion-justify-content-center">
                  <ion-col size="auto" class="ion-no-padding ion-margin-top">
                    <ion-button (click)="headerButtonClick()" class="ion-no-margin" fill="outline" color="secondary">{{ headerButtonText }}</ion-button>
                  </ion-col>
                </ion-row>
              }
            </app-animated-container>
          </div>
        </app-responsive-container>

        <div class="header-padding-bottom"></div>

        <img class="header-overlay" src="images/white-overlay.svg" [alt]="'Overlay' | translate">
      </header>

      <main class="content">
        <app-responsive-container>
          <div class="ion-padding">
            <app-animated-container [routerOutlet]="routerOutlet">
              <ng-content></ng-content>
            </app-animated-container>
          </div>
        </app-responsive-container>

        @if (brandingLayoutService.hideFooter !== true) {
          <footer class="footer">
            <app-responsive-container>
              <div class="ion-padding-horizontal ion-padding-bottom">
                <app-app-information></app-app-information>
              </div>
            </app-responsive-container>
          </footer>
        }
      </main>
    </div>
  </ion-content>
</div>
